import { render } from "./BusinessPlan.vue?vue&type=template&id=14d435c8"
import script from "./BusinessPlan.vue?vue&type=script&lang=js"
export * from "./BusinessPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__